import { isEmpty, isEqual } from 'lodash';
import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { DEFAULT_CANDIDATE } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';

export const updateCandidate = async () => {
    const candidateStore = getStore().candidateStore;
    const selectedCandidateEdit = candidateStore.selectedCandidateEdit;

    if (isEmpty(candidateStore.selectedRegionId) || isEqual(selectedCandidateEdit, DEFAULT_CANDIDATE)) {
        return;
    }

    const issuesKeys = candidateStore.validateCandidateForm();
    if (issuesKeys.length) {
        candidateStore.showMessageModalWithFieldKeys(issuesKeys);
        return;
    }

    candidateStore.setIsUpdatingCandidate(true);

    try {
        await Promise.all([
            candidateStore.updateCandidatePhoto(),
            candidateApi.updateCandidate(selectedCandidateEdit.id, selectedCandidateEdit),
        ]);
        candidateStore.setIsEditMode(false);
        candidateStore.setSelectedCandidateId('');
        candidateStore.getCandidateListByRegionId(candidateStore.selectedRegionId);
    } catch {
        showMessageModal('error', 'Feil under oppdatering av kandidat');
    } finally {
        candidateStore.setIsUpdatingCandidate(false);
        candidateStore.setIsUploadingCandidatePhoto(false);
    }
};
